import { createActions } from 'redux-actions';

const actions = createActions({
  UI: {
    PROBING_PANE: {
      TOGGLE_PANE: undefined,
      SET_WIDTH: undefined,
      SET_TAB: undefined,
      SHOW: undefined,
      HIDE: undefined
    }
  }
});

export default actions;
